import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  login_with_password = environment.loginWithPassword || true;
  apiHostErp = environment.apiHost || 'http://localhost';
  apiPortErp = environment.apiPort || "3001";
  socketPort = environment.socketPort || "3002";
  apiHostDd = environment.apiHostDd || 'http://localhost';
  apiPortDd = environment.apiPortDd || "3000";
  httpUrl = ''; socketUrl = '';
  private baseUrl = this.apiHostDd + ":" + this.apiPortDd + "/dd" ;
  login: boolean = false;
  erpUser: any
  le_id: any = 'princy'
  act_id: any = 1
  clArr: any = {
    "TR": "Business Term", "LR": "Logical Record", "LF": "Logical File", "PF": "Physical File", "DS": "Data Store"
  }
  constructor(private http: HttpClient) {
    console.log(environment.apiHostDd);
    
    if (sessionStorage.getItem('svm_jwt') && sessionStorage.getItem('erpUser')) {
      let erpUserString = sessionStorage.getItem('erpUser');
      this.erpUser = erpUserString && JSON.parse(erpUserString);
      this.le_id = this.erpUser.le_id;
      this.act_id = this.erpUser.b_acct_id
      
    }

  }
  //////////////////utilities/////////////////////////////////////////////
  formatTime(timestamp: string): string {
    const currentTime = new Date();
    const targetTime = new Date(timestamp);

    const timeDifference = Math.abs(currentTime.getTime() - targetTime.getTime());
    const minutes = Math.floor(timeDifference / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return days === 1 ? "1 day ago" : days + " days ago";
    } else if (hours > 0) {
      return hours === 1 ? "1 hour ago" : hours + " hours ago";
    } else if (minutes > 0) {
      return minutes === 1 ? "1 minute ago" : minutes + " minutes ago";
    } else {
      return "just now";
    }
  }
async findData(requestObj: any) {
    const resp = await this.http.post<any>(`${this.apiHostDd}:${this.apiPortDd}/dd`, requestObj).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getListData(req_obj: any): Promise<any> {
    console.log('hiiapi');

    let requestObj: any = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "from": {
        "schema": req_obj['pf_path'],
        "table": req_obj['pf_name']
      },

      "operation": "find",
      "app_cd": "DD"
    }
    if (req_obj.hasOwnProperty('filter') && req_obj.filter !== null && req_obj.filter !== undefined) {
      requestObj['where'] = req_obj.filter;
    }
    if (req_obj.hasOwnProperty('include') && req_obj.include !== null && req_obj.include !== undefined) {
      requestObj['include'] = req_obj.include;
    }
    if (req_obj.hasOwnProperty('limit') && req_obj.limit !== null && req_obj.limit !== undefined) {
      requestObj['limit'] = req_obj.limit;
    }

    if (req_obj.hasOwnProperty('offset') && req_obj.offset !== null && req_obj.offset !== undefined) {
      requestObj.offset = req_obj.offset;
    }
    if (req_obj.hasOwnProperty('order') && req_obj.order !== null && req_obj.order !== undefined) {
      requestObj.order = req_obj.order;
    }

    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        // console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });

  }
  async getBusinessName(req_obj: any): Promise<any> {
    let requestObj: any = {
      "id": {
        "act_id": req_obj['act_id'],
        "jwt": { "uid": "aishwar" }
      },

      "from": {
        "schema": "dd",
        "table": "di"
      },
      "operation": "find",
      "app_cd": "DD",
      "select": [
        "di_id", "di_bus_nm"
      ],
      "where": {
        "and": [
          { "di_tech_nm": { "=": req_obj['di_tech_nm'] } },
          { "di_tcd": { "=": req_obj['di_tcd'] } }

        ]
      }
    }
    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }

  async getMultipleBusinessName(req_obj: any) {
    let requestObj = {
      "id": {
        "act_id": req_obj['act_id'],
        "jwt": { "uid": "aishwar" }
      },

      "from": {
        "schema": "dd",
        "table": "di"
      },
      "select": [
        "di_id", "di_bus_nm", "di_tech_nm"
      ],
      "where": {
        "and": [
          { "di_tech_nm": { "in": [req_obj['di_tech_nm']] } },
          { "di_tcd": { "=": req_obj['di_tcd'] } }

        ]
      }
    }
    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }
  async getAllApplications() {
    let requestObj = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "operation": "find",
      "app_cd": "DD",
      "from": {
        "schema": "dd",
        "table": "di"
      },
      "where": {
        "and": [
          {
            "di_tech_nm": {
              "=": "app_cd"
            }
          }


        ]
      },
      "include": "cl"


    }
    console.log(requestObj);
    
    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }

  async getdtls(req_obj: any) {
    let requestObj = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "from": {
        "schema": "dd",
        "table": "di"
      },
      "operation": "find",
      "app_cd": "DD",

      "where": {
        "and": [
          { "di_tech_nm": { "=": [req_obj['di_tech_nm']] } },
          { "di_tcd": { "=": req_obj['di_tcd'] } }

        ]
      },
      "include": {
        "all": true
      }
    }
    //  console.log(requestObj);

    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        //console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }


  async getdata(req_obj: any) {
    let requestObj = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "from": {
        "schema": "dd",
        "table": "di"
      },
      "operation": "find",
      "app_cd": "DD",

      "where": {
        "and": [

          { "di_tcd": { "=": req_obj['di_tcd'] } }

        ]
      },

    }
    // console.log(requestObj);

    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }
  async addData(req_obj: any): Promise<any> {


    let requestObj: any = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "into": {
        "schema": req_obj['pf_path'],
        "table": req_obj['pf_name']
      },

      "operation": "insert",
      "app_cd": req_obj['app_cd'],
      columns: req_obj['columns'],
      values: req_obj['values']


    }
    // console.log(requestObj);

    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        // console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }
  async addMultiData(req_obj: any): Promise<any> {


    let requestObj: any = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "into": {
        "schema": req_obj['pf_path'],
        "table": req_obj['pf_name']
      },

      "operation": "bulkInsert",
      "app_cd": req_obj['app_cd'],
      columns: req_obj['columns'],
      values: req_obj['values']


    }
    // console.log(requestObj);

    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        // console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }
  async deleteData(req_obj: any) {
    let requestObj = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "from": {
        "schema": req_obj['pf_path'],
        "table": req_obj['pf_name']
      },
      "operation": "destroy",
      "app_cd": req_obj['app_cd'],

      "where": req_obj['where']
    }
    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        // console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }
  async updateData(req_obj: any): Promise<any> {


    let requestObj: any = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "into": {
        "schema": req_obj['pf_path'],
        "table": req_obj['pf_name']
      },

      "operation": "update",
      "app_cd": req_obj['app_cd'],
      set: req_obj['set'],
      where: req_obj['where']


    }
    console.log(requestObj);

    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }

  async initializeApp(req_obj: any): Promise<any> {


    let requestObj: any = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },


      "operation": "initApplication",
      "app_cd": req_obj['app_cd'],
      clear: req_obj['clear'],
      reload: req_obj['reload']


    }
    console.log(requestObj);

    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }
  async pauseApplication(req_obj: any): Promise<any> {


    let requestObj: any = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },


      "operation": "pauseApplication",
      "app_cd": req_obj['app_cd'],
     


    }
    console.log(requestObj);

    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }
  async getAllAppsstatus(): Promise<any> {
    let requestObj: any = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },
      "operation": "getApplicationList",
    }
    console.log(requestObj);

    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }

}
